module.exports = __webpack_public_path__ + "static/media/bg.2be88922.jpg";